import { render, staticRenderFns } from "./AgreementTypeList.vue?vue&type=template&id=476e49ac&"
import script from "./AgreementTypeList.js?vue&type=script&lang=js&"
export * from "./AgreementTypeList.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports